import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {CoreComponent} from "../../../../core/component/core-component/core.component";
import {SignatureDto, SignType} from "../../type/user-signatures.types";
import SignaturePad from "signature_pad";
import {Subscription} from "rxjs";
import {SignaturePadService} from "../../service/signature-pad.service";
import {error} from "@angular/compiler-cli/src/transformers/util";
import {MessageHelper} from "../../../../core/helper/message-helper";
import {AppMessageService} from "../../../../core/service/app-message.service";


@Component({
    selector: 'cross-signatures',
    templateUrl: './signatures.component.html',
    styleUrls: ['./signatures.component.scss']
})
export class SignaturesComponent extends CoreComponent {

  @Input() signatures: SignatureDto[] | undefined;
  @Input() signatureRemovable: boolean = false;
  @Output() signaturesChange = new EventEmitter<SignatureDto[]>;

  private signaturePadSubscription: Subscription = new Subscription();

  public signaturePad?: SignaturePad;
  public signatureModalVisible: boolean = false;

  constructor(protected signaturePadService: SignaturePadService, protected messageService: AppMessageService) {
    super();
  }

  override ngOnInit() {
    this.signaturePadSubscription = this.signaturePadService.currentSignaturePad.subscribe((signaturePad: SignaturePad) => {
      this.signaturePad = signaturePad;
    },error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);
    });
    super.ngOnInit();
  }

  override ngOnDestroy() {
    if (this.signaturePadSubscription) {
      this.signaturePadSubscription.unsubscribe();
    }
    super.ngOnDestroy();
  }

  clearSignaturePad(signature:SignatureDto){
    this.signaturePad?.clear();
    signature.signatureBase64 = null;
    signature.signatureMimeType = null;
    signature.signed = false;
    this.signaturesChange.emit(this.signatures);
  }

  openSignatureModal(signature: SignatureDto){
    if (signature.signed && !this.signatureRemovable) {
      return;
    }
    this.signatureModalVisible = true;
  }

  saveSignature(signature:SignatureDto) {
    if(this.signaturePad){

      let imgString = this.signaturePad.toDataURL('image/png');
      signature.signatureBase64 = imgString.split(",")[1];
      signature.signatureMimeType = 'image/png';
      signature.signed = true;
      signature.signatureTimeStamp = new Date();
    }
    this.signaturesChange.emit(this.signatures);
    this.signatureModalVisible = false;
  }

  onSignatureChange(signature:SignatureDto) {
    if (signature.signatureSwitch) {
      signature.signatureTimeStamp = new Date();
      signature.signed = true;
    } else {
      signature.signatureTimeStamp = undefined;
      signature.signed = false;
    }
    this.signaturesChange.emit(this.signatures);

  }

  protected readonly SignType = SignType;
}
